import { InmateActionTypes, INMATES_LOADING, INMATES_LOAD_FAILURE, INMATES_LOAD_SUCCESS } from '../actions/inmate';
import { PostOfficeActionTypes, SET_INMATE } from '../actions/post-office';
import { IInmate } from '../models/Inmate';

export interface IPostOfficeState {
  inmates: IInmate[];
  inmatesLoading: boolean;
  data: {
    inmate: IInmate;
  };
}

const initialState: IPostOfficeState = {
  inmates: null,
  inmatesLoading: false,
  data: null
};

export function postOfficeReducer(
  state = initialState,
  action: PostOfficeActionTypes | InmateActionTypes
): IPostOfficeState {
  switch (action.type) {
    case SET_INMATE:
      return {
        ...state,
        data: {
          inmate: action.inmate
        }
      };

    case INMATES_LOADING:
      return {
        ...state,
        inmatesLoading: true
      };

    case INMATES_LOAD_SUCCESS:
      return {
        ...state,
        inmates: action.inmates,
        inmatesLoading: false
      };

    case INMATES_LOAD_FAILURE:
      return {
        ...state,
        inmates: null,
        inmatesLoading: false
      };

    default:
      return state;
  }
}